import o from "./_group.js";
import r from "./_has.js";
var p = o(function (o, p, s) {
  r(o, s) ? o[s].push(p) : o[s] = [p];
});
export { p as default };